export default {
    planFirms: { list: [], view: {}, new: {}, edit: {} }
};
